import React from 'react'
import RasterLayer from './RasterLayer'

const IceDriftDeformationShear = () => {
  return (
    <RasterLayer
      id='IceDriftDeformationShear'
      authId='IceDrift'
      />
  )
}

export default IceDriftDeformationShear



// WEBPACK FOOTER //
// ./src/layers/IceDriftDeformationShear.js